angular.module('bribac.components.inactiveDaysDetails', [
    'bribac.translations',
    'bribac.services.api',
    'bribac.components.inactiveDaysEditor',
    'bribac.components.whenLoaded',
    'bribac.decorator.uibDatePicker'
  ])
  .component('inactiveDaysDetails', {
    templateUrl: 'inactive-days-details-component.html',
    controller: 'InactiveDaysDetailCtrl',
    bindings: {
      inactiveDays: '<',
      subject: '<'
    }
  })
  .controller('InactiveDaysDetailCtrl', function(
    $scope,
    api
  ) {

    var $ctrl = this
    var isoStringMillisecondsRegex = /\.\d{3}/
    var date = new Date();

    $ctrl.$onInit = function() {
      getSelectedMonthInactiveDays(date)
    }

    $scope.options = {
      customClass: getDayClass
    };

    function getDayClass(data) {
      var date = data.date;
      for (var i = 0; i < $ctrl.inactiveDays.length; i++) {
        if (new Date($ctrl.inactiveDays[i].day).setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0)) {
          return 'inactive';
        }
      }
      return '';
    }

    //Get Inactive days of subject between a date range
    function getInactiveDays(subjectId, fromDate, toDate) {
      $ctrl.inactiveDaysPromise = api.getInactiveDays(subjectId,
        fromDate.toISOString().replace(isoStringMillisecondsRegex, ''),
        toDate.toISOString().replace(isoStringMillisecondsRegex, ''))
          .then(function success(request) {
            if(request.status == 200) {
              $ctrl.inactiveDays = request.data
              $scope.$broadcast('refreshDatepicker')
            }
      })
    }

    $ctrl.isAnyInactiveDaysEditorFormOpen = function() {
        return $ctrl.addNewInactiveDaysEditorFormIsOpen
    }

    function resetAddNewInactiveDaysForm() {
      $ctrl.addNewInactiveDaysEditorFormIsOpen = false
      getSelectedMonthInactiveDays(date)
    }

    $ctrl.openAddNewInactiveDaysEditorForm = function() {
      $ctrl.addNewInactiveDaysEditorFormIsOpen = true
    }

    $ctrl.onAddNewInactiveDaysSuccess = function(data) {
      resetAddNewInactiveDaysForm()
    }

    $ctrl.onAddNewInactiveDaysCancel = resetAddNewInactiveDaysForm

    $scope.$on('monthChanged', function(event, date) {
      if(date && !$ctrl.isAnyInactiveDaysEditorFormOpen()) {
        getSelectedMonthInactiveDays(date)
      }
    });

    function getSelectedMonthInactiveDays(date) {
      $ctrl.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      $ctrl.lastDay = new Date(date.getFullYear(), date.getMonth() + 1);
      getInactiveDays($ctrl.subject.id, $ctrl.firstDay, $ctrl.lastDay)
    }
});